// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2proe","right":"styles_right__2PZ_M"};